import { withConfigTransport } from '../../services/config-transport'
import _VaTextarea from './VaTextarea.vue'

export const VaTextarea = withConfigTransport(_VaTextarea)
